import LogoutPage from './logout';

export default LogoutPage;
